import classNames from "classnames";
import React, { useState } from "react";
import { Controller } from "react-hook-form";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import get from "lodash.get";
export default function TextInput({
  name,
  stepOff,
  minVal = 0,
  placeholder,
  control,
  errors,
  rules,
  type,
  disabled,
  className,
  labelClassName,
  label,
  leftIcon,
  rightIcon,
  onBlur,
  topClassName,
  onChange: customOnChange,
  ...rest
}) {
  const [showPassword, setShowPassword] = useState(false);
  const errorMessage = get(errors, name)?.message;

  return (
    <div className={classNames("w-full flex flex-col justify-between relative  ", topClassName)}>

      <Controller
        render={({ field: { onChange, value, ref } }) => (
          <>
            {label && (
              <label
                className={classNames(
                  labelClassName,
                  "mb-2.5 block text-navy  text-sm font-helvetica font-semibold"
                )}
              >
                {label}
              </label>
            )}
            <div className="relative ">
              {leftIcon && (
                <div className="absolute left-3 flex items-center h-full">
                  {leftIcon}
                </div>
              )}
              <input
                ref={ref}
                type={type === "number" ? "text" : showPassword ? "text" : type}
              className={classNames(
  "w-full appearance-none h-11 rounded-lg border placeholder-placholderColor font-medium text-sm text-black font-helvetica  border border-borderColor bg-white py-2 pl-4 pr-12 outline-none focus:border-primary focus-visible:shadow-none",
  "overflow-hidden whitespace-nowrap text-ellipsis",
  "placeholder:overflow-hidden placeholder:font-normal placeholder:text-ellipsis placeholder:whitespace-nowrap",
  className
)}

                aria-invalid={errors && (errorMessage)? "true" : "false"}
                aria-describedby={`${name}Error`}
                placeholder={placeholder}
                onInput={(e) => {
                  const inputValue = e.target.value;
                  const decimalCount = (inputValue.match(/\./g) || []).length;
                  if (inputValue < minVal) {
                    e.target.setCustomValidity(`Min val should be ${minVal} `);
                  } else {
                    e.target.setCustomValidity(``);
                  }
                  if (
                    type === "number" &&
                    (decimalCount > 1 ||
                      isNaN(Number(inputValue)) ||
                      (type === "number" && !/^\d*\.?\d*$/.test(inputValue)))
                  ) {
                    e.target.value = inputValue.slice(0, -1);
                  }
                }}
                onChange={(e) => {
                  onChange(e);
                  if (customOnChange) {
                    customOnChange(e);
                  }
                }}
                onBlur={onBlur}
                value={value || ""}
                disabled={disabled}
                autoComplete="off"
                aria-autocomplete="none"
                min={minVal}
                step={stepOff ? "1" : "0.01"}
                name={name}
                {...rest}
              />
              {type === "password" && (
                <div
                  className="cursor-pointer absolute right-3 top-0 flex items-center h-full"
                  onClick={() => setShowPassword(!showPassword)}
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      setShowPassword(!showPassword);
                    }
                  }}
                >
                  {showPassword ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
                </div>
              )}
              {rightIcon && (
                <div className="absolute right-3 top-0 flex items-center h-full">
                  {rightIcon}
                </div>
              )}
            </div>
          </>
        )}
        name={name}
        control={control}
        rules={rules}
      />


      {/* {errors?.[name] && (
        <p className="text-[#f00] text-[12px]">
          <span role="alert" id={`${name}Error`}>
            {errors[name]?.message}
          </span>
        </p>
      )} */}
      {errorMessage && (
        <p className="text-[#f00] text-[12px]">
          <span role="alert" id={`${name}Error`}>
            {errorMessage}
          </span>
        </p>
      )}
    </div>
  );
}
